export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const DIGITAL_PROCUREMENT_URL = process.env.REACT_APP_DIGITAL_PROCUREMENT_URL || "";
export const SECRET = process.env.REACT_APP_SECRET || "";
export const AXIOS_CONFIG = {
	headers: {
		"Access-Control-Allow-Origin": "*",
	},
};